import { formatCurrency } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'overflow',
})
export class OverflowPipe implements PipeTransform {
  transform(input: any, args?: any): any {
    Number.parseInt(input)
    const suffixes = ['M', 'B']
    const THOUSAND = 1000
    const TWO = 2

    if (Number.isNaN(input)) {
      return null
    }
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (input < 1000000) {
      return formatCurrency(input, 'en-US', '$', 'USD', '1.0-0')
    }
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const exp = Math.floor(Math.log(input) / Math.log(1000))
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return (
      '$' +
      (input / Math.pow(THOUSAND, exp)).toFixed(args) +
      ' ' +
      suffixes[exp - TWO]
    )
  }
}
